export const userApiQueryKeys = {
  me: () => ['me'] as const,
};
